import AdvisorCreateMap from "../../../components/DataCollection/Advisor/AdvisorCreateMap/AdvisorCreateMap";

export const AdvisorCreateMapScreen = () => {
  return (
    <div>
      <AdvisorCreateMap />
    </div>
  );
};
